export default "__VITE_ASSET__CamyO8zd__"